import React from 'react';
import { GlobalLeaderboardEntry } from '../types';
import LeaderboardRow from './LeaderboardRow';
import EmptyState from '../../../../components/UI/EmptyState';
import styles from '../../../../styles/LeaderBoard.module.css';

interface LeaderboardTableProps {
  entries: GlobalLeaderboardEntry[];
  highlightedRow: number | null;
  onRowHover: (index: number) => void;
  onRowLeave: () => void;
  currentUserId?: string;
  isWorkMode?: boolean;
}

const LeaderboardTable: React.FC<LeaderboardTableProps> = ({
  entries,
  highlightedRow,
  onRowHover,
  onRowLeave,
  currentUserId,
  isWorkMode = true
}) => {
  if (entries.length === 0) {
    return (
      <EmptyState
        image="/images/notasks.png"
        title="No leaderboard data"
        description="No entries found for the selected filters. Try adjusting your filters to see more results."
      />
    );
  }

  return (
    <div className={styles.leaderboardTableContainer}>
      <table className={styles.leaderboardTable}>
        <thead>
          <tr>
            <th className={styles.rankColumn}>Rank</th>
            <th className={styles.memberColumn}>Member</th>
            <th className={styles.groupColumn}>Group</th>
            <th className={styles.pointsColumn}>Points</th>
            <th className={styles.tasksColumn}>Tasks</th>
            <th className={styles.qualityColumn}>Quality</th>
            {isWorkMode && <th className={styles.actionsColumn}>Actions</th>}
          </tr>
        </thead>
        <tbody>
          {entries.map((entry, index) => (
            <LeaderboardRow
              key={`${entry.user.id}-${entry.group.id}`}
              entry={entry}
              index={index}
              isHighlighted={highlightedRow === index}
              isCurrentUser={currentUserId ? (entry.user.id === currentUserId || entry.user.email === currentUserId) : false}
              onMouseEnter={() => onRowHover(index)}
              onMouseLeave={onRowLeave}
              isWorkMode={isWorkMode}
            />
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default LeaderboardTable;

